import { MetricNature } from '@upright/common/model/input/types';
import { ApiPaiValue } from '@upright/common/model/output/eu-regulation/resolved-pais/types';
import { RequestStatus } from '@upright/ui/api/common/types';
import { usePaiLensContext } from '@upright/ui/common/upright/core/impact-lenses/pais/common/use-pai-lens-context';
import Skeleton from 'react-loading-skeleton';
import { values } from 'lodash';

export function PaiLensSourceDescription() {
  const ctx = usePaiLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const items = data.pais;
  if (!items) {
    return <>Error</>;
  }
  return <>{toSourceDescription(values(items))}</>;
}

function toSourceDescription(data: ApiPaiValue[]) {
  const anyDirectDisclosures = !!data.find(d => d.nature === MetricNature.DIRECT_DISCLOSURE);
  const anyNonDirectDisclosures = !!data.find(d => d.nature !== MetricNature.DIRECT_DISCLOSURE);
  if (anyDirectDisclosures && anyNonDirectDisclosures) {
    return 'Upright net impact model, direct disclosures';
  } else if (anyDirectDisclosures) {
    return 'Data provided by the company';
  } else {
    return 'Upright net impact model';
  }
}
